export function generateCookieDomain(domain?: string) {
  return domain || `.${process.env.TARGET_ENV_PREFIX}myrealtrip.com`;
}
